import { LoggerProvider as BaseLoggerProvider } from "@bindery/logging/react";
import type { ReactNode } from "react";
import { recordLanding } from "../lib/attribution";
import { logging } from "./backend";
import { setUnhandledErrorReporter } from "./earlyErrorCapture";
import { visitIds } from "./visitId";

const errorCapture = { setUnhandledErrorReporter };

export function LoggerProvider({ children }: { children: ReactNode }) {
  return (
    <BaseLoggerProvider
      logging={logging}
      errorCapture={errorCapture}
      visits={visitIds}
      resolveLeadId={recordLanding}
    >
      {children}
    </BaseLoggerProvider>
  );
}
